module.exports = __webpack_public_path__ + "static/img/advertisement-1.f90c8f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement-1.png
// module id = SmrF
// module chunks = 1